import { render, staticRenderFns } from "./WsReadSection.vue?vue&type=template&id=6b754fb2&"
import script from "./WsReadSection.vue?vue&type=script&lang=js&"
export * from "./WsReadSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports